import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import * as PCLNAnalytics from '../../utils/PCLN-Analytics'
import { ANALYTICS_CATEGORY } from '../../constants/Constants'

export default (
  {
    category = ANALYTICS_CATEGORY,
    action,
    // dictionary of GA labels to send to PCLNAnalytics based on the form key
    events = {}
  } = {}
) => Component => {
  class AnalyticsForm extends React.Component {
    static propTypes = {
      onChange: PropTypes.func,
      GACategory: PropTypes.string
    }

    fireAnalytics = ({ current, next, key, eventKey, index }) => {
      if (
        get(next.values, key) === get(current.values, key) ||
        get(next.values, key) === null
      ) {
        return
      }

      const customCategory =
        typeof category === 'function' ? category(next.values) : category
      const customAction =
        typeof action === 'function'
          ? action(next.values, eventKey, index)
          : action
      const label = get(events, eventKey || key)
      if (!label) return
      const data =
        typeof label === 'function' ? label(next.values, index) : label
      if (!data) return

      // TODO: Brute-force GA to be improved for PKG form's partial stay GA
      //       action. Figure out how to refactor the GA action logic away
      PCLNAnalytics.send({
        category: customCategory,
        action:
          key === 'partialStay' || key === 'hotelEndDate'
            ? 'VP Partial Stay'
            : customAction,
        data
      })
    }

    handleChange = (current, next) => {
      const { onChange } = this.props
      if (onChange) {
        onChange(current, next)
      }
      if (current.values === next.values) return
      if (
        !!current.values.locationObject &&
        current.values.locationObject === next.values.locationObject &&
        current.values.location !== next.values.location
      ) {
        return
      }
      if (
        !!current.values.startLocationObject &&
        current.values.startLocationObject ===
          next.values.startLocationObject &&
        current.values.startLocation !== next.values.startLocation
      ) {
        return
      }
      if (
        !!current.values.endLocationObject &&
        current.values.endLocationObject === next.values.endLocationObject &&
        current.values.endLocation !== next.values.endLocation
      ) {
        return
      }

      for (const key in next.values) {
        // TODO: Brute-force GA to be improved
        //       PKG form's partial stay date logic can be refactored out of
        //       HOC. But the current implementation can't work with the caller
        //       of this HOC in NEW_SEARCH_SearchForms/Package.js until
        //       caller could determine the "touched" hotel start & end dates
        const isKeyPartialDate =
          key === 'hotelStartDate' || key === 'hotelEndDate'
        const isPartialDateDelta =
          current.values.hotelStartDate !== next.values.hotelStartDate ||
          current.values.hotelEndDate !== next.values.hotelEndDate

        if (isKeyPartialDate && next.values.partialStay && isPartialDateDelta) {
          const isCheckIn = !next.values.hotelEndDate
          PCLNAnalytics.send({
            category,
            action: 'VP Partial Stay',
            data: isCheckIn
              ? `${next.values.hotelStartDate === next.values.startDate
                ? 'Matching'
                : 'Unique'} check-in date`
              : `${next.values.hotelEndDate === next.values.endDate
                ? 'Matching'
                : 'Unique'} check-out date`
          })
          continue
        }

        // for multihotel scenarios
        if (Array.isArray(next.values[key]) && Array.isArray(current.values[key])) {
          if (next.values[key].length === current.values[key].length) {
            next.values[key].forEach((item, index) => {
              for (let itemKey in item) {
                const itemKeyName =
                  itemKey === 'locationObject'
                    ? 'locationObject.itemName'
                    : itemKey

                this.fireAnalytics({
                  current,
                  next,
                  key: `${key}[${index}].${itemKeyName}`,
                  eventKey: `${key}.${itemKeyName}`,
                  index
                })
              }
            })
          }
          continue
        }

        if (!action) return

        this.fireAnalytics({ current, next, key })
      }
    }

    handleAnalyticsOnClick = (gaAction, gaLabel, props) => {
      const { GACategory } = props
      PCLNAnalytics.send({
        category: GACategory,
        action: gaAction,
        data: gaLabel
      })
    }

    render () {
      return (
        <Component
          {...this.props}
          onChange={this.handleChange}
          handleAnalyticsOnClick={(gaAction, gaLabel) => this.handleAnalyticsOnClick(gaAction, gaLabel, this.props)}
        />
      )
    }
  }

  return AnalyticsForm
}
